module.exports = __webpack_public_path__ + "static/img/40特许加盟.88260ba.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo/40特许加盟.jpg
// module id = jfoY
// module chunks = 1